import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { PolicyRouter } from '../../../policy/types';
import { modules } from '../../modules';

@injectable()
export class PolicyRouterService implements PolicyRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToCreate() {
    this.history.push(`/${this.role.get()}/${modules.policy.basename}/create`);
  }

  goToDetail(id: string, query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.policy.basename}/${id}`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.policy.basename}/${id}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.policy.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.policy.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToEdit(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.policy.basename}/edit/${id}`,
    );
  }

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }
}
